import React, { useEffect, useState } from 'react'
import authorizeGetRequestWOT from '../api/authorizeGetRequestWOT';
import authorizePatchMultipart from '../api/authorizePatchMultipart';
import Swal from 'sweetalert2';
import fallBackImage from '../assets/human-silhouette.avif'
import backImg from '../assets/cover_photo.avif'

const Profile = () => {
  const [user, setUser] = useState();
  const [refresh, setRefresh] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [password, setPassword] = useState('');
  const [img, setImg] = useState('');
  const [imgPreview, setImgPreview] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if(loading) return;
    const getData = async () => {
      setLoading(true);
      await authorizeGetRequestWOT('user/userprofile')
        .then((response) => {
          if (response.user) {
            setUser(response.user)
          } else {
            Swal.fire({
              position: 'top-end',
              toast: true,
              width: 600,
              // background: '#F47E52',
              icon: 'error',
              titleText: response.message,
              showConfirmButton: true,
              timer: 5000,
            });
          }
        })
        .catch((err) => {
          console.log(err)
          Swal.fire({
              position: 'top-end',
              toast: true,
              width: 600,
              // background: '#F47E52',
              icon: 'error',
              titleText: err.message ?? 'An error occured',
              showConfirmButton: true,
              timer: 5000,
            });
        });
      setLoading(false);
    }
    getData();
  }, [refresh]);

  const getUserLevel = () => {
    if(!user)
      return '...'
    if (user.userlevel == 3) 
      return "All previlages"
    else if (user.userlevel == 2) 
      return "All mobile previlages"
    else 
      return "Mobile app cases previlages only"
  }

  const handleEdit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();
    if (img) {
      formData.append('avatar', img);
    }
    formData.append('firstName', user.firstName);
    formData.append('lastName', user.lastName);
    await authorizePatchMultipart(`user/userprofile/${user.id}`, formData)
    .then((response1) => {
      Swal.fire({
        position: 'top-end',
        toast: true,
        width: 600,
        // background: '#F47E52',
        icon: 'success',
        titleText: response1.message,
        showConfirmButton: false,
        timer: 2500,
      });
      setRefresh(!refresh);
    })
    .catch((err) => {
      console.log('mobileAppFeed error', err);
      Swal.fire({
        position: 'top-end',
        toast: true,
        width: 600,
        // background: '#F47E52',
        icon: 'error',
        titleText: err.message,
        showConfirmButton: false,
        timer: 2500,
      });
    });
    setLoading(false);
  }

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();
    formData.append('currentPassword', currentPassword);
    formData.append('password', password);
    await authorizePatchMultipart(`user/userprofile/${user.id}`, formData)
    .then((response1) => {
      Swal.fire({
        position: 'top-end',
        toast: true,
        width: 600,
        // background: '#F47E52',
        icon: 'success',
        titleText: response1.message,
        showConfirmButton: false,
        timer: 2500,
      });
    })
    .catch((err) => {
      console.log('mobileAppFeed error', err);
      Swal.fire({
        position: 'top-end',
        toast: true,
        width: 600,
        // background: '#F47E52',
        icon: 'error',
        titleText: err.message,
        showConfirmButton: false,
        timer: 2500,
      });
    });
    setLoading(false);
  }

  const handleImgChange = e => {
    let image = new Image();
    image.src = URL.createObjectURL(e.target.files[0]);
    image.onload = async () => {
      setImg(e.target.files[0]);
      setImgPreview(URL.createObjectURL(e.target.files[0]));
    };
  }

  return (
    <>
      <div class="panel-header panel-header-sm">
      </div>
      <div class="content">
        <div class="row">
          <div class="col-md-8">
            <div class="card">
              <div class="card-header">
                <h5 class="title">Edit Profile</h5>
              </div>
              <div class="card-body">
                <form method='post' onSubmit={handleEdit}>
                  <div className="form-group">
                    <label for="exampleInputEmail1">First Name</label>
                    <input type="text" value={user?.firstName ?? ''} onChange={(e) => setUser({...user, firstName: e.target.value})} className="form-control form-control-lg" id="exampleInputEmail1" required />
                  </div>
                  <div className="form-group">
                    <label for="exampleInputEmail1">Last Name</label>
                    <input type="text" value={user?.lastName ?? ''} onChange={(e) => setUser({...user, lastName: e.target.value})} className="form-control form-control-lg" id="exampleInputEmail1" required />
                  </div>
                  <div className='form-group mt-4 mb-4'>
                    <label className='mr-2' htmlFor='subject'>Avatar</label>
                    <input
                      type="file"
                      name='img'
                      accept="image/*"
                      multiple={false}
                      onChange={handleImgChange}
                    // className='form-control form-control-lg'
                    />
                    <img src={imgPreview} width={150} height={150} />
                  </div>
                  
                  <button className="btn btn-lg btn-primary btn-block" type="submit">Update info</button>
                </form>

                <hr className='my-2' />
                  <div class="card-header">
                  <h5 class="title">Change Password</h5>
                </div>

                <form className='' method='post' onSubmit={handlePasswordChange}>
                  <div className="form-group">
                    <label for="currentPassword">Current Password</label>
                    <input type="text" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} className="form-control form-control-lg" required />
                  </div>
                  <div className="form-group">
                    <label for="newPassword">New Password</label>
                    <input type="text" value={password} onChange={(e) => setPassword(e.target.value)} className="form-control form-control-lg" required />
                  </div>
                  
                  <button className="btn btn-lg btn-primary btn-block" type="submit">Update password</button>
                </form>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card card-user">
              <div class="image">
                <img src={backImg} alt="..." />
              </div>
              <div class="card-body">
                <div class="author">
                  <a href="#">
                    <img class="avatar border-gray" src={user?.avatar ?? fallBackImage} alt="..." />
                      <h5 class="title">{ user?.firstName } { user?.lastName }</h5>
                  </a>
                  <p class="description">
                    { user?.email }
                  </p>
                </div>
                <p class="description text-center">
                  <span className='text-black fw-bold'>Account created</span> <br />
                    {(user && user.created_at ) ? new Date(user.created_at).toDateString() : '' }
                </p>
              </div>
              <hr />
                <div class="button-container">
                  <div class="bg-neutral fs-6 text-success">
                    {getUserLevel()}
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Profile
